import {
  fetchGetNewbuildingsFromBuilder,
  TGetNewbuildingsFromBuilderResponse,
} from 'shared/repositories/newbuilding-search/v1/get-newbuildings-from-builder';

import { ResponseError } from '../../errors';
import { prepareSimilarNewobjects } from '../../mappers/prepareSimilarNewobjects';
import { IApplicationContext } from '../../types/applicationContext';
import { ISimilarNewobject } from '../../types/similarNewobjects';

interface IParameters {
  builderIds: number[];
  regionId: number;
  newbuildingIdToSkip: number;
}

export async function fetchNewobjectsBuilder(
  context: IApplicationContext,
  parameters: IParameters,
): Promise<ISimilarNewobject[] | null> {
  const { httpApi, logger } = context;

  try {
    const newobjectsBuilderResponse: TGetNewbuildingsFromBuilderResponse = await fetchGetNewbuildingsFromBuilder({
      httpApi,
      parameters,
    });

    if (newobjectsBuilderResponse.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchNewobjectsBuilder',
        message: newobjectsBuilderResponse.response?.message || '',
        details: { errors: JSON.stringify(newobjectsBuilderResponse.response?.errors) },
      });
    }

    return prepareSimilarNewobjects(newobjectsBuilderResponse.response);
  } catch (ex) {
    logger.warning(ex, {
      degradation: 'Similar newobjects from builder',
    });

    return null;
  }
}
